<template>
  <v-tooltip v-if="tooltip" top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" :color="color" :size="size">{{ icon }}</v-icon>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
  <v-icon v-else :color="color" :size="size">{{ icon }}</v-icon>
</template>

<script>
import displayMixin from './mixin'

export default {
  name: 'ConstructVisualDisplayMdi',
  mixins: [displayMixin],
  computed: {
    icon() {
      const value = String(this.resolveValue(this.item.value, this.item.source, '')).trim()
      return /^mdi-[a-z0-9-]+$/i.test(value) ? value : 'mdi-information-outline'
    },
    color() { return this.resolveValue(this.item.color, this.item.colorSource) || undefined },
    size() { return Number(this.resolveTemplate(this.item.size)) || 24 },
    tooltip() { return this.resolveTemplate(this.item.tooltip) },
  },
}
</script>
